import { tv } from 'tailwind-variants'

import { body2, h3 } from '@ui-kit/core/typography'

export const cardInfo = tv({
  slots: {
    container: `flex grow flex-col rounded-lg border border-solid bg-ui-light p-3`,
    header: 'flex flex-row items-start justify-between',
    title: h3({ className: 'pr-2' }),
    descriptionContainer: 'flex grow flex-col justify-center',
    description: body2(),
  },
  variants: {
    compact: {
      true: {
        container: 'w-[160px]',
      },
    },
  },
  defaultVariants: {
    compact: false,
  },
})
